import { render, staticRenderFns } from "./downUpCenter.vue?vue&type=template&id=e71d4224&scoped=true&"
import script from "./downUpCenter.vue?vue&type=script&lang=js&"
export * from "./downUpCenter.vue?vue&type=script&lang=js&"
import style0 from "./downUpCenter.vue?vue&type=style&index=0&id=e71d4224&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71d4224",
  null
  
)

export default component.exports